import React from 'react';
import SecondaryAction from '../../_components/actions/SecondaryAction';
import useDialogLauncher from '../../../../hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '../../../dialogs_new/DialogManager';
import useNetwork from '../../../hooks/useNetwork';
import { OutlineButton } from '../../../@communityshare/ui/Button';

export default function Header(props) {
  const { supportQuestion } = props;

  const launch = useDialogLauncher();

  function onClick() {
    launch(DialogManager.NetworkSupportQuestionCreate.Config(supportQuestion.id));
  }

  return (
    <div className="flex flex-col space-y-1">
      <div className="text-sm text-cs-gray-500">
        {/*<GrayTag label={supportQuestion.data.audience} />*/}
        {supportQuestion.data.audience}
      </div>
      <div className="flex justify-between">
        <div className="flex flex-1 space-y-0.5 w-full">
          <div>
            <div className="text-lg font-semibold text-cs-gray-900">
              {supportQuestion.data.question}
            </div>
            {/*<div className="text-sm text-cs-gray-500">*/}
            {/*  /!*<GrayTag label={supportQuestion.data.audience} />*!/*/}
            {/*  {supportQuestion.data.audience}*/}
            {/*</div>*/}
          </div>
        </div>
        <div className="flex space-x-2">
          <div>
            <OutlineButton onClick={onClick}>
              Add Contact
            </OutlineButton>
          </div>
        </div>
      </div>
    </div>
  );
}
